// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qXYA4","colMin":"styles_colMin__1aFl_"};